import React, {useEffect, Profiler} from "react";
import {useDispatch} from "react-redux";
import {setVideoTerm} from "../../redux_slices/videoPageSlice";
import {setIsVideoPage} from "../../redux/Layout/layoutSlice";

//components:
import MediaDashboard from "./MediaDashboard";

const MediaItemPage = props => {
    const {match} = props;

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setIsVideoPage(true));

        return () => {
            dispatch(setIsVideoPage(false));
            dispatch(setVideoTerm({text: "", time: "", type: ""}));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Profiler id="mediaViewerPage">
            <MediaDashboard match={match} page="videos" />
        </Profiler>
    );
};

export default MediaItemPage;
